/**
 * App environment vars mapping for types
 */
const environment = {
  apiUrl: process.env.REACT_APP_API_URL,
  strictEmail: process.env.REACT_APP_STRICT_EMAIL === 'true'
};

export { environment };
